import { createFileRoute } from '@tanstack/react-router'
import { DocumentosLista } from '@/features/documentos/lista'
import { requireAtestadosAccess } from '@/lib/route-guards'
import { DOCUMENTO_STATUS_VALUES, type DocumentoStatus } from '@/types/documento-status'

/** Link vindo de um relatório: já abre a lista buscando o colaborador (ex.: RE) e no status certo. */
export type DocumentosSearch = { busca?: string; status?: DocumentoStatus }

export const Route = createFileRoute('/_authenticated/documentos/')({
  beforeLoad: async () => {
    await requireAtestadosAccess()
  },
  validateSearch: (s: Record<string, unknown>): DocumentosSearch => ({
    busca: typeof s.busca === 'string' && s.busca.trim() ? s.busca.trim() : undefined,
    status: (DOCUMENTO_STATUS_VALUES as readonly string[]).includes(s.status as string)
      ? (s.status as DocumentoStatus)
      : undefined,
  }),
  component: DocumentosLista,
})
